module.exports = __webpack_public_path__ + "img/bfd1bec0c63d1317297541103a29330.4cd1fec7.jpg";